import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes, ElementType } from 'react';

import { DigiprocAtomAbstract } from '@/services/types/digiproc-atom-abstract';

const headingVariants = cva(
  'font-heading font-bold leading-normal tracking-tightest',
  {
    variants: {
      variant: {
        h1: 'text-5xl',
        h2: 'text-4xl',
        h3: 'text-2xl',
        h4: 'text-xl',
        intro: 'text-lg sm:text-xl lg:text-2xl',
      },
      tone: {
        default: 'text-dp-blue-800',
        mint: 'text-dp-mint-800',
        inverse: 'text-dp-white',
      },
    },
    defaultVariants: { variant: 'h2', tone: 'default' },
  }
);

type HeadingProps = DigiprocAtomAbstract<HTMLAttributes<HTMLHeadingElement>> &
  VariantProps<typeof headingVariants> & {
    as?: ElementType;
  };

export const Heading = ({
  variant = 'h2',
  tone,
  as,
  children,
  ...rest
}: HeadingProps) => {
  const Tag = (as ?? variant ?? 'h2') as ElementType;
  return (
    <Tag {...rest} className={headingVariants({ variant, tone })}>
      {children}
    </Tag>
  );
};
